import { AxiosResponse } from 'axios'

import { CustomHttpErrorMessage } from '@/components/features/error/CustomHttpErrorMessage/type'
import { ERROR_MESSAGE } from '@/const'

export type Field<RequestParams extends { [key in string]: unknown }> = {
  name: keyof RequestParams
  value?: string
  reasons: {
    type: keyof typeof ERROR_MESSAGE
  }[]
}

export type CustomHttpErrorObject = {
  name: string
  message: string
  customMessage: CustomHttpErrorMessage
  stack?: string
  http: {
    status: number
    statusText: string
  }
}
export class CustomHttpError extends Error {
  status: number
  statusText: string
  customMessage: CustomHttpErrorMessage

  constructor(response: AxiosResponse, customMessage: CustomHttpErrorMessage) {
    super(response.statusText)
    this.name = 'CustomHttpError'
    this.status = response.status
    this.statusText = response.statusText
    this.customMessage = customMessage
  }

  serialize(): CustomHttpErrorObject {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      http: {
        status: this.status,
        statusText: this.statusText,
      },
      customMessage: this.customMessage,
    }
  }
}
